import React from "react";
import profimg from "../Components/img/profile.jpg";

const Home = () => {
  return (
    <div className="container">
      {/* Top Section */}
      <header className="home-header hero-wrapper">
        <div className="hero-overlay">
          <span className="name-title">Sean Spijkers</span>
          <h1 className="name-use">Photography • Design</h1>
        </div>
      </header>

      {/* About Me Section */}
      <section className="about-section">
        <div className="about-text">
          <h2>About me</h2>
          <p>
            I’m a visual creative working across photography and design with a
            strong focus on storytelling, movement and atmosphere. My work
            centres on capturing moments that feel authentic and intentional.
            Whether in fast-paced environments or carefully constructed visual
            narratives. Alongside photography, I work in visual design. Applying
            the same principles of clarity, balance and concept-driven thinking.
            I help brands and individuals build strong visual identities through
            thoughtful design, consistency and narrative across platforms. My
            personal work explores the relationship between humans, urban
            environments and nature. Examining themes of time, space and
            adaptation in the modern world. This research-led approach informs
            both my commercial and creative projects.
          </p>
        </div>
        <div className="about-image">
          <img src={profimg} alt="Sean Spijkers" />
        </div>
      </section>
      <button className="download-cv-button">
        <a
          href="Sean Spijkers 2025 CV.pdf"
          download
          style={{ textDecoration: "none", color: "inherit" }}
        >
          Download CV
        </a>
      </button>

      {/* Education Section */}
      <section>
        <h2 className="education-title">Education</h2>
        <div className="education-grid">
          <div className="education-card">
            <h4>2024</h4>
            <h3>
              BA Degree - Visual Communication (Major in Photography and Design)
            </h3>
            <p>Open Window</p>
          </div>
          <div className="education-card">
            <h4>2021</h4>
            <h3>Diploma - Visual Communication </h3>
            <p>CTU Training Solutions</p>
          </div>
          <div className="education-card">
            <h4>2018</h4>
            <h3>National Senior Certificate</h3>
            <p>Afrikaanse Hoër Seunskool</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
